"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Card = _interopRequireDefault(require("../../Card"));

var _theme = _interopRequireDefault(require("../../../theme"));

var _styledComponents = require("styled-components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var UncheckedIcon = function UncheckedIcon() {
  return _react["default"].createElement(_Card["default"], {
    borderRadius: 9999,
    border: "2px solid",
    borderColor: "neutral.500",
    width: 22,
    height: 22
  });
};

UncheckedIcon.defaultProps = {
  theme: _theme["default"]
};

var _default = (0, _styledComponents.withTheme)(UncheckedIcon);

exports["default"] = _default;